import { IReference } from '@framework/engine';
import { IAdvancedRichText } from '@framework/engine/src/inputs/rich-text-advanced/IAdvancedRichText';
import { WidgetType } from '@framework/engine/src/schema/widgets/Widget';
import { IInputWidget } from '@framework/engine/src/schema/widgets/repository/inputs/IInputWidget';

// export interface IButtonWidgetLayout extends IBaseLayoutOptions {
//   iconType?: IconType;
//   buttonType?: ButtonType;
//   buttonAlign?: ButtonAlign;
// }
// import type { Widget as BaseWidget } from '@framework/engine/src/schema/widgets/Widget';
// declare module '@framework/engine/src/schema/widgets/Widget' {
//   export type Widget = BaseWidget | ICompetenceWidget;
// }

export const WidgetTypeCompetence = 'competence' as WidgetType.Competence;

/**
 * Seleziona competenze
 */
export interface ICompetenceWidget extends IInputWidget {
  id: string;
  type: WidgetType.Competence;
  label?: IAdvancedRichText;
  layout?: IInputWidget['layout'] & { hide?: boolean };
  sourceValueReference?: IReference | null;
}
